import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useStyles } from "./OurSloutionsStyle";
import IndustrialSolutions from "./IndustrialSolutions";

const OurSloutions = () => {
  const classes = useStyles();
  return (
    <Box className={classes.MainContainer} id="nos-solutions">
      <Box className={classes.HeadingBox}>
        <div data-aos="flip-up" data-aos-delay="200">
          <Typography className={classes.TitleSolutionHeading}>
            Le <span className={classes.BimTitle}> BIM</span> pour{" "}
            <span className={classes.TitleSolutionHeadingSpan}>
              L’industrie
            </span>
          </Typography>
        </div>
        <div data-aos="zoom-in-up">
          <Typography className={classes.HeadingBoxParagraphy}>
            De la Maquette à la Réalité Connectée : vos données industrielles
            prennent vie
          </Typography>
        </div>
        <div data-aos="zoom-out" data-aos-delay="200">
          <Box className={classes.TransportationMainContainer}>
            <IndustrialSolutions />
          </Box>
        </div>
      </Box>
    </Box>
  );
};

export default OurSloutions;
